module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "lightbox"
    }
  }, [_c('div', {
    staticClass: "lightbox-mask"
  }, [_c('div', {
    staticClass: "lightbox-wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "lightbox-container"
  }, [_c('div', {
    staticClass: "lightbox-body"
  }, [_vm._t("body")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "lightbox-close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('close')
      }
    }
  }, [_vm._t("close", function() {
    return [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      }
    })])]
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5693cd86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Lightbox.vue
// module id = 113
// module chunks = 0